export const webEntries = [
  { path: '/farmRunningStatus', title: '运行状态', icon: 'el-icon-data-analysis', admin: true },
  { path: '/users', title: '账号管理', icon: 'el-icon-user', admin: true },
  { path: '/dispatchCenter', title: '调度中心', icon: 'el-icon-connection', button: '1', business: true },
  { path: '/irrigationPlans', title: '轮灌计划', icon: 'el-icon-date', button: '2' },
  { path: '/waterFertilizerScheme', title: '水肥方案', icon: 'el-icon-s-operation', button: '3' },
  { path: '/farmingRecords', title: '农事记录', icon: 'el-icon-notebook-2', button: '4' },
  { path: '/patrolRecords', title: '巡田记录', icon: 'el-icon-document-checked', button: '5' },
  { path: '/expertDecision', title: '专家决策', icon: 'el-icon-reading', button: '6' }
]
export function availableEntries(session) {
  const buttons = String(session && session.profile && session.profile.appButtons || '').split(',').map(value => value.trim())
  return webEntries.filter(item => item.admin ? session && session.level === 2 : buttons.includes(item.button))
}

export function safeWebRedirect(router, value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/web/home'
  const route = router.resolve(value).route
  if (!route.matched.length || ['/login', '/'].includes(route.path)) return '/web/home'
  const query = { ...route.query }
  query.webApp = '1'
  query.os = 'web'
  delete query.redirect
  delete query.webtitle
  return { path: route.path, query, hash: route.hash }
}

export function webDispatchReturn(router, route) {
  const value = route.query.fromDispatch
  if (route.path !== '/equipment' || typeof value !== 'string' || !value.startsWith('/dispatchCenter?')) return ''
  const target = router.resolve(value).route
  return target.path === '/dispatchCenter' && target.query.webApp === '1' &&
    typeof target.query.farmId === 'string' && target.query.farmId !== '' && target.query.farmId === route.query.farmId
    ? target.fullPath : ''
}

const pageTitles = {
  '/develop': '功能开发中', '/headPump': '泵房', '/headRollCurtain': '卷帘机', '/headGate': '闸门',
  '/headGateway': '网关', '/headFertilizationTank': '施肥罐', '/headU680': 'U680',
  '/headFertilizerMachine': '施肥机', '/headControlCabinet': '控制柜',
  '/changhongSoilMoisture': '长虹墒情站', '/changhongWeatherStation': '长虹气象站',
  '/greenhouseSensor': '温室传感器', '/jishiyuInsectStation': '及时雨虫情站',
  '/renkeInsectStation': '任科虫情站', '/environmentSensor': '环境监测传感器',
  '/waterQuality': '水质监测仪', '/sporeCollector': '孢子仪',
  '/thirdPartyInsecticidalLamp': '第三方杀虫灯', '/changhongInsecticidalLamp': '长虹杀虫灯',
  '/accumulatedTemperatureLight': '积温积光仪', '/temperatureHumidity': '温湿度采集器',
  '/insectStation': '虫情站', '/weatherStation': '气象站', '/insecticidalLamp': '杀虫灯',
  '/soilMoisture': '墒情站', '/equipment': '设备控制', '/ezplay': '视频监控', '/deviceStatus': '设备状态'
}
export function webPageTitle(route) {
  const query = route.query
  if (route.path === '/login') return '登录'
  if (route.path === '/web/home' && query.panel === 'farms') return '农场管理'
  if (route.path === '/web/home') return ({ head: '首部', irrigation: '灌溉', monitor: '监测', garden: '庭院', profile: '我的' })[query.tab] || '农场首页'
  if (route.path === '/web/settings') return query.section === 'font' ? '字体大小' : '设置'
  if (route.path === '/web/manage') return query.kind === 'gateway' ? '网关管理' : '地块管理'
  // Preserve the device name or contextual title supplied by existing entry links.
  if (typeof query.title === 'string' && query.title.trim()) return query.title
  if (route.path === '/dispatchCenter' && query.gis === 'true') return 'GIS地图'
  const entry = webEntries.find(item => item.path === route.path)
  return entry ? entry.title : pageTitles[route.path] || '优联智控'
}
